import axios from "axios";
import {AccessKey} from "@cabinet-packages/helpers";
import moment from "moment";

export const startInterpretation = async (hash, note) => {
 const data = {
  note,
 };

 return await axios.post(`/api/selection/start/${hash}`, data);
}

export const statusOfInterpretation = async (orderId) => {


 return await axios.get(`/interpretation/api/selection/${orderId}/status`);
}

export const getResultForInterpretation = async (hash) => {

 return await axios.get(`/interpretation/api/report/getResult/${hash}`);
}

export const getHashForQuick = async (orderId) => {


 return await axios.get(`/interpretation/api/selection/${orderId}/hash`);
}

export const getAllInterpretations = async (state) => {
 const accessKey = AccessKey.get();
 let searchString =`?dtFrom=${moment(state.dtFrom).format('YYYY-MM-DD')}&dtTo=${moment(state.dtTo).format('YYYY-MM-DD')}`;
 const searchField = state.searchField

 const isId = !!searchField && !Number.isNaN(+searchField) && +searchField > 0

 if (!!searchField && isId) {
  searchString += `&requestId=${searchField}`;
 } else if (!!searchField) {
  searchString += `&patient=${searchField}`;
 }

const res = await axios.get(`/api/doctors/interpretation/requests`+searchString,

 {
  headers: {
   Authorization: "Bearer " + accessKey,
   AccessPhone: localStorage.getItem('activePatientPhone')

  },
 }
)
 return res.data;
}

export const getInterpretationById = async (id) => {
 const accessKey = AccessKey.get();

 const res = await axios.get(`/api/doctors/interpretation/request/${id}`,

  {
   headers: {
    Authorization: "Bearer " + accessKey,
    AccessPhone: localStorage.getItem('activePatientPhone')

   },
  }
 )
 return res.data;
}

export const getInterpretationByHash = async (hash) => {
 const accessKey = AccessKey.get();

 const res = await axios.get(`/api/doctors/interpretation/request/application/${hash}`,

  {
   headers: {
    Authorization: "Bearer " + accessKey,
    AccessPhone: localStorage.getItem('activePatientPhone')

   },
  }
 )
 return res.data;
}

export const exchangeToken = async () => {
 const accessKey = AccessKey.get();

 const res = await axios.get(`/api/auth/doctor/token/exchange`,

  {
   headers: {
    Authorization: "Bearer " + accessKey,
    AccessPhone: localStorage.getItem('activePatientPhone')

   },
  }
 )
 return res.data;
}

export const getInterpretationOrderById = async (id) => {
 const accessKey = AccessKey.get();

 const res = await axios.get(`/api/doctors/interpretation/order/${id}`,

  {
   headers: {
    Authorization: "Bearer " + accessKey,
    AccessPhone: localStorage.getItem('activePatientPhone')

   },
  }
 )
 return res.data;
}

export const getInterpretationFields = async (id) => {
 const accessKey = AccessKey.get();

 const res = await axios.get(`/api/doctors/interpretation/result/${id}`,

  {
   headers: {
    Authorization: "Bearer " + accessKey,
    AccessPhone: localStorage.getItem('activePatientPhone')

   },
  }
 )
 return res.data;
}

export const confirmInterpretation = async (orderId) => {
 const accessKey = AccessKey.get();


 return await axios.put(`/api/doctors/interpretation/request/accept/${orderId}`, undefined,{
  headers: {
   Authorization: "Bearer " + accessKey,
   AccessPhone: localStorage.getItem('activePatientPhone')

  },
 });
}

export const rejectInterpretation = async (orderId) => {
 const accessKey = AccessKey.get();


 return await axios.put(`/api/doctors/interpretation/request/reject/${orderId}`, undefined,{
  headers: {
   Authorization: "Bearer " + accessKey,
   AccessPhone: localStorage.getItem('activePatientPhone')

  },
 });
}

export const rejectAcceptedInterpretation = async (selectionId) => {
 const accessKey = AccessKey.get();


 return await axios.put(`/api/doctors/interpretation/reject/${selectionId}`, undefined,{
  headers: {
   Authorization: "Bearer " + accessKey,
   AccessPhone: localStorage.getItem('activePatientPhone')

  },
 });
}

export const saveInterpretation = async (data, selectionId) => {
 const accessKey = AccessKey.get();


 return await axios.put(`/api/doctors/interpretation/save/${selectionId}`, data,{
  headers: {
   Authorization: "Bearer " + accessKey,
   AccessPhone: localStorage.getItem('activePatientPhone')

  },
 });
}

export const createInterpretation = async (orderId,note = '') => {
 const accessKey = AccessKey.get();

 const data = {
  note,
 };

 return await axios.post(`/api/doctors/interpretation/request/${orderId}`, data,{
  headers: {
   Authorization: "Bearer " + accessKey,
   AccessPhone: localStorage.getItem('activePatientPhone')

  },
 });
}

export const createInterpretationRequest = async (interpretationId) => {
 const accessKey = AccessKey.get();

 const data = {
 };

 return await axios.post(`/api/doctors/interpretation/create/${interpretationId}`, data,{
  headers: {
   Authorization: "Bearer " + accessKey,
   AccessPhone: localStorage.getItem('activePatientPhone')

  },
 });
}

// createInterpretation(6186076)
